<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="600px"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">
          Please Complete Contact Information
        </span>
      </v-card-title>
      <v-card-subtitle>
        <span class="first--text">
          you must complete any required information before adding/selecting a contact.
        </span>
      </v-card-subtitle>
      <v-card-text>
        <v-form
          ref="contact_form"
          v-model="valid"
          lazy-validation
        >
          <v-row>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="contactForm.first.value"
                :rules="contactForm.first.rules"
                label="First Name*"
                required
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="contactForm.last.value"
                :rules="contactForm.last.rules"
                label="Last Name*"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="contactForm.email.value"
                :rules="contactForm.email.rules"
                label="Email*"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="contactForm.phone.value"
                :rules="contactForm.phone.rules"
                label="Phone Number*"
                required
                v-mask="'(###) ###-####'"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="contactForm.title.value"
                :rules="contactTitle ? contactForm.title.rules : []"
                :label="'Title' + (contactTitle ? '*' : '')"
                :required="contactTitle"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="red darken-1"
          text
          @click="() => cancelContactModal()"
        >
          Close
        </v-btn>
        <v-btn
          color="third darken-1"
          text
          @click="() => validate()"
        >
          {{ getAction }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ContactForm',
  props: {
    show: { type: Boolean, required: false },
    action: { type: String, required: false },
    values: { type: Object, require: true },
    contactTitle: {
      type: Boolean,
    },
  },
  data() {
    return {
      valid: true,
      contactForm: {
        first: {
          value: null,
          rules: [
            (v) => !!v || 'Name is required',
            (v) => (v && v.length <= 10) || 'Name must be less than 10 characters',
          ],
        },
        last: {
          value: null,
          rules: [
            (v) => !!v || 'Name is required',
            (v) => (v && v.length <= 10) || 'Name must be less than 10 characters',
          ],
        },
        email: {
          value: null,
          rules: [
            (v) => !!v || 'E-mail is required',
            (v) => /^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/.test(v) || 'E-mail must be valid',
          ],
        },
        phone: {
          value: null,
          rules: [
            (v) => !!v || 'Phone Number is required',
          ],
        },
        title: {
          value: null,
          rules: [
            (v) => !!v || 'Title is required',
          ],
        },
        roles: {
          value: [],
        },
      },
    };
  },
  methods: {
    cancelContactModal() {
      this.$emit('cancelModal', true);
      this.reset();
    },
    validate() {
      if (this.$refs.contact_form.validate()) {
        // if valid emit data back
        this.$emit('updateContact', {
          first: this.contactForm.first.value,
          last: this.contactForm.last.value,
          fullname: `${this.contactForm.first.value} ${this.contactForm.last.value}`,
          email: this.contactForm.email.value,
          phone: this.contactForm.phone.value,
          title: this.contactForm.title.value,
          roles: [...this.contactForm.roles.value],
          pin: this.contactForm.pin.value,
          company: this.contactForm.company.value,
          address: this.contactForm.address.value,
          ordernumber: this.contactForm.ordernumber.value,
        });

        this.reset();
      }
    },
    reset() {
      this.$refs.contact_form.reset();
    },
  },
  computed: {
    getAction() {
      if (this.action) {
        return this.action;
      }
      return 'update';
    },
  },
  watch: {
    values: {
      handler(val) {
        const keys = Object.keys(val);
        keys.forEach((key) => {
          if (this.contactForm[key]) {
            this.contactForm[key].value = val[key] || '';
          }
        });
      },
      deep: true,
    },
  },
};
</script>
